// gonna add some overrides for other headings but we've not yet seen
// what they look like in the wild
// we could add our own of course but i'll check with gwil as to his preference

export const headingStylesForPanelsAndCards = `.chameleon-text {

  h3, h3 * {
    line-height: 1em;
  }

  h4 {
    font-size: 1.2rem;
    line-height: 1.2em;
  }

  h5 {
    font-size: 1rem;
    line-height: 1.2em;
  }

  h6 {
    font-size: 1rem;
    line-height: 1.2em;
  }
}`;
